import { faChalkboardUser as faChalkboardUserRegular } from '@fortawesome/pro-regular-svg-icons'
import { faChalkboardUser as faChalkboardUserSolid } from '@fortawesome/pro-solid-svg-icons'

import { getTutorUrl } from '@/client/services/url'

export const NAVBAR_DESKTOP_WIDTH = '100px'

export const TUTOR_NAVIGATION_ITEM_DESKTOP = {
  href: getTutorUrl(),
  icons: {
    inactive: faChalkboardUserRegular,
    active: faChalkboardUserSolid,
  },
  label: 'My Tutoring',
  labelBeforeTutorInterest: 'Become a Tutor',
}
